module.exports = __webpack_public_path__ + "img/man-standing-beside-his-wife-teaching-th.315f4295.webp";